import React, {forwardRef} from 'react';

import {Button, ButtonInterface} from '@veneer/core';

import useStyles from './useStyles';

type ButtonProps = Omit<ButtonInterface, 'appearance' | 'className'> & React.HTMLAttributes<HTMLButtonElement>;

// eslint-disable-next-line prefer-arrow-callback
const WFCButton = forwardRef<HTMLButtonElement, ButtonProps>(function WFCButton({...rest}: ButtonProps, ref) {
    const styles = useStyles();

    return (
        <Button
            ref={ref}
            className={styles.button}
            appearance="ghost"
            {...rest}
        />
    );
});

export default WFCButton;
